import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addAppointments = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_appointment',
    '/api/resource/Patient Appointment',
    body
  );
  return data;
});
export const updateAppointmentsWorkflow = catchAsync(async (status) => {
  const { data } = await axiosInstance.post(
    // `/api/method/technoerp.services.update_appointment_workflow?appointment=${status.record}&status=${status.status}`
    `/api/method/technoerp.services.update_appointment_workflow?appointment=${status.record}&status=${status.status}`
  );
  return data;
});
export const updateAppointments = catchAsync(async (id, body) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_appointment',
    `/api/resource/Patient Appointment/${id}`,
    body
  );
  return data;
});

export const getAppointments = catchAsync(async ({ value, key }) => {
  let baseUrl = `/api/resource/Patient Appointment?fields=["name","custom_mobile","appointment_type", "practitioner", "practitioner_name", "department", "appointment_date", "patient", "patient_name", "patient_sex", "patient_age", "appointment_time", "workflow_state"]&limit_start=0&limit_page_length=0&order_by=name desc`;
  if (value) {
    // const filterData = key === "appointment_date" ? `[["appointment_date","Between",["${value}","${value}"]]]` : value
    // const filterData = value
    const filterBlusPhone =
      key === 'custom_mobile'
        ? value?.startsWith('+')
          ? value?.substring(1)
          : value?.startsWith('966')
          ? value
          : `966${value}`
        : key === 'patient'
        ? value?.startsWith('P-')
          ? value
          : `P-${value}`
        : value;
    //  console.log(filterData,"filterData");
    if (key === 'appointment_date') {
      baseUrl += `&filters=[["appointment_date","Between",["${value}","${value}"]]]`;
    } else {
      baseUrl += `&filters=[["${key}","like","%${filterBlusPhone}%"]]`;
    }
  }
  // console.log(baseUrl,"baseUrl");

  const { data } = await axiosInstance.get(
    baseUrl
    // '/api/method/technoerp.services.get_appointments'
    // `/api/method/technoerp.services.get_appointments?${searchText.key}=${searchText.value}`
  );
  return data;
});
export const getPatients = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_patients'
  );
  return data;
});
export const deleteAppointments = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Patient Appointment/${id}`
    // `/api/method/technoerp.services.delete_record?record=${record}&document=Patient%20Appointment`
  );
  return data;
});
export const getAppointmentTypes = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_appointment_types'
  );
  return data;
});

export const getAppointmentsDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_appointment?appointment=${id}`
    `/api/resource/Patient Appointment/${id}`
  );
  return data;
});

export const getAvailableTimeSlots = catchAsync(
  async ({ practitioner, appointment_date, service_unit, schedule }) => {
    const { data } = await axiosInstance.post(
      `/api/method/technoerp.services.get_available_time_slots?practitioner=${practitioner}&appointment_date=${appointment_date}&service_unit=${service_unit}&schedule=${schedule}`
    );
    return data;
  }
);

export const getSearchPatients = catchAsync(async (type, searchTxt = '') => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.search?type=Patient&filters={"is_sales_item":1}&txt=${searchTxt}`
    `/api/method/technoerp.services.search?type=${type}&txt=${searchTxt}`
  );
  return data;
});

export const getSearchApiIsGroup = catchAsync(
  async (type = '', searchTxt = '') => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.search?type=${type}&txt=${searchTxt}&filters:[["is_group","=","0"]]`
    );
    return data;
  }
);
export const getSearchApiTypeIsGroup = catchAsync(
  async ({ type = '', text = '' }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.search?type=${type}&txt=${text}&filters:[["is_group","=","0"]]`
    );
    return data;
  }
);
export const getSearchApiIsStock = catchAsync(
  async ({ type = '', text = '', stock = 1 }) => {
    const { data } = await axiosInstance.get(
      `/api/method/technoerp.services.search?type=${type}&txt=${text}&filters:[["is_stock_item","=","${stock}"]]`
    );
    return data;
  }
);

export const getListTimeSlots = catchAsync(async ({ practitioner, date }) => {
  const response = await axiosInstance.get(
    `/api/method/technoerp.services.get_available_time_slots?practitioner=${practitioner}&date=${date}`
  );
  return response.data;
});
export const cancelAppointments = catchAsync(async (name) => {
  const response = await axiosInstance.post(
    `/api/method/technoerp.services.cancel_appointment?id=${name}&status=Cancelled`
  );
  return response.data;
});
